import {fabric} from "fabric";
import store from "../../store";

export const addImg = async (url) => {
    const photoPromise = new Promise(resolve => fabric.Image.fromURL(url, (myImg) => {
        myImg.set({
            selectable: false
        });
        resolve(myImg);
    },{crossOrigin: 'Anonymous'}));
    store.dispatch('IN_PROGRESS', photoPromise, {root: true});

    return photoPromise
}
